function updateCustomText() {
  const colorInput = document.querySelector('.color-option-selector input:checked');
  const textInputs = document.querySelectorAll('.product-custom-text');

  if (colorInput) {
    const colorValue = colorInput.value.trim().toLowerCase();
    const colorCode = 'color-' + colorValue;
    console.log('Selected color value:', colorCode);

    textInputs.forEach(input => {
      input.setAttribute('data-color', colorCode);
      console.log('Set data-color on text input:', input, '->', colorCode);
    });
  }

  // Get selected color option
  const colorSelect = document.querySelector('.custom-color-select select');
  const selectedOption = colorSelect?.options[colorSelect.selectedIndex];
  const color = selectedOption?.getAttribute('data-color');

  let bgColor = null;
  if (colorInput) {
    const selectOption = colorInput.closest('.select-option');
    const label = selectOption?.querySelector('label');
    if (label) {
      const lableBG = window.getComputedStyle(label).background;
      const matches = lableBG.match(/rgb\(\d+,\s*\d+,\s*\d+\)/g);
      if (matches && matches.length >= 2) {
        bgColor = matches[1];
      }
      if (!bgColor) {
        bgColor = window.getComputedStyle(label).backgroundColor;
      }
    }
  }

  const fontInput = document.querySelector('.font-radio input:checked');
  const font = fontInput?.getAttribute('data-font');

  const input = document.querySelectorAll('.product-custom-text.custom-text input');
  if (input) {
    console.log('bgColor: ', bgColor, 'color: ', color, 'font: ', font);
    input.forEach((ip) => {
      let style = '';
      if (bgColor) style += `background-color: ${bgColor.replace(/\s/g, '')};`;
      if (color) style += `color: ${color.replace(/\s/g, '')};`;
      if (font) style += `font-family: '${font}';`;
      ip.setAttribute('style', style.trim());
    });
  }
}

document.addEventListener('change', updateCustomText);


document.addEventListener('DOMContentLoaded', function () {
  updateCustomText();

  setTimeout(() => {
    const select = document.querySelector('.custom-color-select');
    if (select) {
      select.addEventListener('click', function() {
        const changeEvent = new Event('change', { bubbles: true });
        select.dispatchEvent(changeEvent);
      });
    }
  }, 700);
  

  const customCheckbox = document.querySelector('.custom-option.ui.checkbox');

  customCheckbox?.addEventListener('click', function () {
    document.querySelectorAll('.open-module-checkbox input').forEach(function(input) {
      input.click();
    });
  });

  const checkboxes = document.querySelectorAll('.open-module-checkbox input');
  const target = document.querySelector('.maatwerk-module-customs');

  function toggleModuleCustoms() {
    const anyChecked = document.querySelectorAll('.open-module-checkbox input:checked').length > 0;
    console.log('click', target, anyChecked)
    if (target) {
      if (anyChecked) {
        // Slide down
        target.style.display = 'block';
        target.style.height = 'auto';
        const height = target.scrollHeight + 'px';
        target.style.height = '0px';
        setTimeout(() => {
          target.style.transition = 'height 0.4s ease';
          target.style.height = height;
        }, 10);
        setTimeout(() => {
          target.style.height = 'auto';
          target.style.transition = '';
        }, 400);
      } else {
        // Slide up
        const height = target.scrollHeight + 'px';
        target.style.height = height;
        setTimeout(() => {
          target.style.transition = 'height 0.4s ease';
          target.style.height = '0px';
        }, 10);
        setTimeout(() => {
          target.style.display = 'none';
          target.style.transition = '';
          target.style.height = 'auto';
        }, 400);

        setTimeout(() => {
          const inputs = target.querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
              if (input.type === 'checkbox' || input.type === 'radio') {
                  input.checked = false;
              } else {
                  input.value = '';
              }
          });
        });
      }
    }
  }

  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', toggleModuleCustoms);
  });
});



document.addEventListener("DOMContentLoaded", function() {
  const embroiderySelect = document.getElementById('product_configure_select_embroidery');
  const embroideryInput = document.querySelector('input[data-embroidery]');
  const addToCartBtn = document.querySelector('.js-product-form-main button[type="submit"]');
  const productForm = document.querySelector('.js-product-form-main'); 
  // const mainVariantId = document.querySelector('.js-product-form-main input[name="id"]').value; 


  if (!addToCartBtn || !productForm || (!embroiderySelect && !embroideryInput)) return;

  addToCartBtn.addEventListener("click", async function(e) {
    const mainVariantId = document.querySelector('.js-product-form-main input[name="id"]').value; 
    e.preventDefault();

    const timestamp = Date.now().toString();

    const properties = {};
    document.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').forEach(el => {
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (!match) return;

      if ((el.type === "radio" || el.type === "checkbox")) {
        if (el.checked) {
          properties[match[1]] = el.value;
        }
      } else {
        properties[match[1]] = el.value;
      }
    });

    const embroiderySelected =
    (embroiderySelect &&
      (embroiderySelect.value === "voorkant" ||
      embroiderySelect.value === "achterkant")) ||
    document.querySelector('input[data-embroidery]:checked') !== null;

    let borduurVariantId = null;
    if (embroiderySelected) {
      if (embroideryInput && embroideryInput.dataset.variantId) {
        console.log('variant id borduur: ', borduurVariantId)
        borduurVariantId = embroideryInput.dataset.variantId;
      } else if (embroiderySelect && embroiderySelect.dataset.variantId) {
        borduurVariantId = embroiderySelect.dataset.variantId;
        console.log('variant id borduur: ', borduurVariantId)
      }
    }

    if (embroiderySelected) {
      console.log('embroidery!')
      properties["_Parent"] = timestamp;
    } else {
      console.log('geen embroidert')
    }

    const quantityInput = document.querySelector('.qty-input__input');
    const quantity = parseInt(quantityInput.value, 10) || 1;

    console.log('quantity: ', quantity)
    console.log('properties1: ', properties)
    const items = [{
      id: mainVariantId,
      quantity: quantity,
      properties
    }];

    if (embroiderySelected) {
      items.push({
        id: borduurVariantId,
        quantity: quantity,
        parent_id: mainVariantId,
        properties: { 
          "_Borduur": "Ja",
          "_Extra": "Ja",
          "_Parent": timestamp 
        }
      });
    }

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Toevoegen...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      location.reload();
    } catch (err) {
      console.error(err);
      addToCartBtn.textContent = 'Fout, probeer opnieuw';
      setTimeout(() => {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Toevoegen aan winkelwagen';
      }, 2000);
    }
  });
});
